import { setWebIcon, setWebTitle } from '@/utils'
import logoSvg from '@/assets/icons/perf/logo.svg'
import { checkPerfPremision } from '../hooks/useCheckPerf'
import { PerfAssessPages, PerfTansferPage } from './assess.route'
import PerfManagePages from './manage.route'

const PerfPages = [
  {
    path: 'perf',
    component: () => import('../layout/index.vue'),
    beforeEnter() {
      setWebIcon(logoSvg)
      setWebTitle('绩效')
      return checkPerfPremision()
    },
    children: [
      {
        path: 'noproject',
        component: () => import('../components/403/index.vue'),
        meta: { name: '403页面提示' },
      },
      // 绩效评估相关评估
      PerfTansferPage,
      PerfAssessPages,
      // 项目管理相关评估
      PerfManagePages
    ]
  }
]
export default PerfPages
